import Cookies from "js-cookie";
import { get } from 'lodash'
import store from '../store'
import { mapState } from 'vuex'

export function getToken() {
    return Cookies.get("Token");
}

export function hasToken() {
    return Cookies.get("Token") ? true : false;
}

export function setToken(token) {
    return Cookies.set("Token", token);
}

export function removeToken() {
    return Cookies.remove("Token");
}

export function checkRedirectToken (to){
    let auth = get(to, 'meta.auth')

    if(!auth){
        return false;
    }

    return getToken() ? false : true;
}
